const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const menu = [
  {
    text: "Home",
    props: {
      to: "/",
    },
  },
  {
    text: "Sobre",
    props: {
      to: "/sobre",
    },
  },
  {
    text: "Transportes",
    props: {
      to: "/transportes",
    },
  },
  {
    text: "Agro",
    props: {
      to: "/agro",
    },
  },
  {
    text: "Responsabilidade",
    dropdown: [
      {
        text: "Social",
        props: {
          to: "/responsabilidade-social",
        },
      },
      {
        text: "Ambiental",
        props: {
          to: "/responsabilidade-ambiental",
        },
      },
    ],
  },
  {
    text: "Trabalhe Conosco",
    props: {
      to: "/trabalhe-conosco",
    },
  },
  {
    text: "Fale Conosco",
    props: {
      to: "/fale-conosco",
    },
  },
];

export { server, menu };
